<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
      >
        <EditableDropdown
          v-model="activeItem"
          :items="activeItems"
          :item-text="treeStructure.text"
          :label="label"
          :clearable="clearable"
          readonly
          @clear="clear"
        >
          <template v-slot:prepend-inner>
            <TreeviewIcon
              :active-item="activeItem"
              :artefact="treeStructure.artefact"
            />
          </template>
        </EditableDropdown>
      </div>
    </template>

    <v-card>
      <v-card-text class="ma-0 pa-0">
        <v-text-field
          v-model="search"
          :label="$t('search')"
          class="search-input"
          clearable
        />
        <div class="overflow-scroll" style="max-height: 400px;" ref="test">
          <TreeviewPanel
            ref="treeviewPanel"
            :active-item.sync="activeItem"
            :trees="[treeStructure]"
            :search="search"
            :filters="filters"
            only-treeview
          />
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import TreeviewPanel from '@/components/Utilities/Treeview/TreeviewPanel'
import TreeviewIcon from '@/components/Utilities/Treeview/TreeviewIcon'

export default {
  components: {
    TreeviewIcon,
    TreeviewPanel
  },

  props: {
    value: {
      type: [String, Object, null],
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: 'treeview'
    },
    tree: {
      type: Object,
      required: false,
      default: () => ({})
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      menu: false,
      activeItem: null,
      treeStructure: {},
      search: ''
    }
  },

  computed: {
    activeItems () {
      return this.activeItem
        ? [this.activeItem]
        : []
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        this.activeItem = value
      }
    },

    tree: {
      immediate: true,
      deep: true,
      handler (tree) {
        this.treeStructure = {
          artefact: tree?.artefact || null,
          items: tree?.items || [],
          key: tree?.key || 'value',
          text: tree?.text || 'text',
          children: tree?.children || 'children',
          loading: false,
          loaded: true,
          menu: false,
          insertable: false,
          editable: false,
          onSelect: (activeItem) => {
            this.$emit('input', activeItem)
            this.menu = false
          }
        }
      }
    }
  },

  methods: {
    /**
     * Clear event.
     */
    clear () {
      // Reset active item.
      this.activeItem = null
      // Emit input.
      this.$emit('input', this.activeItem)
    }
  }
}
</script>

<style lang="scss" scoped>
.overflow-scroll {
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.search-input {
  display: inline-block;
  width: 100%;
}

.search-input ::v-deep .v-text-field__details {
  min-height: 1px;
}

.search-input ::v-deep .v-input__slot {
  padding: 0px 30px 10px 30px;
  margin-bottom: 0;
}
</style>
